:host {
  display: block;
}

.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
}

.modal:not(.modal--open) {
  // A transition-friendly alternative to `display: none` for hiding content
  overflow: hidden;
  pointer-events: none;
  visibility: hidden; // prevent tab stops and screen reader discovery
}

.modal--open .modal__overlay {
  opacity: 0.5;
}

.modal:not(.modal--open) .modal__overlay {
  transition-delay: 0.3s;
}

.modal--open .modal__panel {
  display: flex;
  flex-direction: column;
}

.modal--open .modal__body {
  opacity: 1;
}

.modal--open .modal__header {
  opacity: 1;
}

.modal--open .modal__footer {
  opacity: 1;
}

.modal--popin .modal__panel {
  -webkit-transform: translateY(0);
  -moz-transform: translateY(0);
  -ms-transform: translateY(0);
  transform: translateY(0);
  opacity: 1;
}

.modal--popout .modal__panel {
  -webkit-transform: translateY(20%);
  -moz-transform: translateY(20%);
  -ms-transform: translateY(20%);
  transform: translateY(20%);
  opacity: 0;
}

.modal__panel {
  position: relative;
  width: 100vw;
  background-color: white;
  z-index: 2;
  border-radius: var(--border-radius, #{$border-radius});

  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);

  @media (min-width: 576px) {
    width: calc(66rem - 3.2rem);
    height: auto;
    max-height: 85vh;
  }
}

.modal--small .modal__panel {
  text-align: left;
  align-self: flex-end;
  height: auto;
  max-height: 85vh;

  @media (min-width: 576px) {
    max-width: calc(62.8rem - 3.2rem);
    align-self: initial;
  }

  .modal__header {
    @media (max-width: 575.98px) {
      padding: 1.6rem;
      padding-top: 4rem;
    }
  }

  .modal__body {
    @media (max-width: 575.98px) {
      padding-top: 4rem;
    }
  }

  .modal__header ~ .modal__body {
    @media (max-width: 575.98px) {
      padding-top: 0;
    }
  }

  hr {
    @media (max-width: 575.98px) {
      display: none;
    }
  }

  h2 {
    @media (max-width: 575.98px) {
      font-size: 2.6rem;
      @include font-weight(500);
    }
  }
}

.modal--medium .modal__panel {
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100); /*  https://css-tricks.com/the-trick-to-viewport-units-on-mobile  */

  @media (min-width: 576px) {
    max-width: calc(62.8rem - 3.2rem);
    height: 100%;
  }
}

.modal--large .modal__panel {
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100); /*  https://css-tricks.com/the-trick-to-viewport-units-on-mobile  */

  @media (min-width: 576px) {
    width: 100vw;
    max-width: calc(132rem - 3.2rem);
    height: 100%;
  }
}

.modal__header {
  display: block;
  opacity: 0;
  padding: 1.6rem;

  @media (min-width: 576px) {
    padding: 2.4rem;
  }

  h2 {
    font-size: 1.8rem;
    line-height: 1.3;
    letter-spacing: 0.015rem;
    @include font-weight(600);
    color: var(--o2-blue-brand, #{$blue-brand});
    margin: 0;
  }
}
.modal--has-close {
  .modal__header h2 {
    padding-right: 3.2rem;
  }

  @media screen and (max-width: 767px) {
    &.modal--small .modal__header h2 {
      padding-right: 0;
    }
  }
}

.modal__pull {
  position: absolute;
  display: block;
  width: 100%;
  height: 0.5rem;
  top: 2rem;
  align-self: center;

  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTQiIGhlaWdodD0iNSIgdmlld0JveD0iMCAwIDU0IDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAyLjVDMCAxLjExOTI5IDEuMTE5MjkgMCAyLjUgMEg1MS41QzUyLjg4MDcgMCA1NCAxLjExOTI5IDU0IDIuNUM1NCAzLjg4MDcxIDUyLjg4MDcgNSA1MS41IDVIMi41QzEuMTE5MjkgNSAwIDMuODgwNzEgMCAyLjVaIiBmaWxsPSIjQzdENEUxIi8+Cjwvc3ZnPgo=');
  background-repeat: no-repeat;
  background-position-x: 50%;

  @media (min-width: 576px) {
    display: none;
  }
}

.modal__close {
  border: none;
  border-radius: 50%;
  background: transparent;
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  padding: 0;

  @media screen and (min-width: 576px) {
    top: 2.4rem;
    right: 2.2rem;
  }

  o2-icon {
    cursor: pointer;
    color: var(--o2-secondary, #{$secondary});
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  }

  &:hover o2-icon {
    opacity: 0.5;
  }

  &:focus-visible {
    @include focus-visible($outline-offset: 0, $border-radius: 1.6rem);
  }
}

.modal__body {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  opacity: 0;

  padding-inline: 1.6rem;
  padding-top: 1.6rem;
  padding-bottom: 1.6rem;

  .modal__header ~ & {
    padding-top: 0;
  }

  @media (min-width: 576px) {
    padding-inline: 2.4rem;
    padding-top: 2.4rem;
    padding-bottom: 2.4rem;

    .modal__header ~ & {
      padding-top: 0;
    }
  }
}

.modal__footer {
  display: flex;
  flex: 0 0 auto;
  flex-flow: wrap;
  justify-content: flex-end;
  opacity: 0;
  flex-flow: column-reverse;
  padding: 1.6rem;

  @media (min-width: 576px) {
    flex-flow: row;
    padding: 2rem 3.2rem;
  }

  &.modal__footer--shadow {
    box-shadow: 0px -2px 20px rgba(142, 142, 142, 0.25);
  }

  ::slotted(o2-button[slot='primary']) {
    margin-bottom: $spacing-4;
    @media (min-width: 576px) {
      margin-left: $spacing-4;
      margin-bottom: 0;
    }
  }
}

.modal__overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: $body-color;
  opacity: 0;
  transition: all 0.3s;
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
}

hr {
  margin: 1.6rem 0 0 0;
  color: $gray-light;
  background-color: currentColor;
  border: 0;
  opacity: 0.5;

  @media (min-width: 576px) {
    margin: 2rem 0 0 0;
  }
}

hr:not([size]) {
  height: 1px;
}

.swiper {
  &.modal--small {
    @media (max-width: 575.98px) {
      height: 100vh; /* Fallback for browsers that do not support Custom Properties */
      height: calc(var(--vh, 1vh) * 100); /*  https://css-tricks.com/the-trick-to-viewport-units-on-mobile  */

      .modal__close {
        display: none;
      }
    }

    .swiper-slide--fake {
      @media (min-width: 768px) {
        display: none;
      }
    }
  }

  &.modal--medium,
  &.modal--large {
    .swiper-slide--fake {
      display: none;
    }
  }
}
